import React, { memo, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTheme } from '@material-ui/core/styles'

import History from '../panels/history'

import Data from '../panels/data'

import TreeOfKnowledge from '../panels/treeOfKnowledge'

import WidgetIFrame from '../panels/customWidget'

import { setActiveWidget } from '../../../redux/dock/actions'

import DockMenu from '../../atoms/dockMenu'

import useStyles from './dockStyle'
import SummarizationWidget from '../panels/summarizationWidget'

const Dock = (props) => {
  const dispatch = useDispatch()

  const theme = useTheme()
  const activeConversation = useSelector((state) => state.activeConversation)

  const conversation = useSelector(
    (state) => state.conversations.conversations[activeConversation]
  )
  const relatedComponents = conversation?.relatedComponents

  const [widgetsList, setWidgetsList] = useState({})
  const widgets = useSelector((state) => state.widgets)
  const haveLink = widgets.conversations?.[activeConversation]?.find(
    (e) => e?.data?.url
  )

  const widgetSelected =
    useSelector((state) => state.dock?.[activeConversation]) || 'attendance'

  const classes = useStyles()

  //IFRAME
  const showWidgets = () => {
    return Object.values(widgetsList)?.map((e) =>
      Object.values(e).map((el, key) => (
        <>
          {el.data && (
            <WidgetIFrame
              key={key}
              id={`${el.chatId}${el?.id}`}
              isOpen={
                widgetSelected === 'link' && activeConversation === el?.chatId
              }
              setWidgetsList={setWidgetsList}
              {...el}
            />
          )}
        </>
      ))
    )
  }

  useEffect(() => {
    const widgetPayload = relatedComponents?.widgets

    if (activeConversation && widgetPayload?.data?.length > 0) {
      setWidgetsList((prev) => ({
        ...prev,
        [widgetPayload.chatId]: {
          ...Object.assign(
            ...widgetPayload?.data?.map((k) => ({ [k?.widgetId]: k }))
          ),
        },
      }))
    }
  }, [widgets?.conversations, setWidgetsList])

  useEffect(() => {
    if (widgetSelected === 'link' && haveLink) {
      const chatId = activeConversation

      if (widgetsList[chatId]?.unMount) {
        setWidgetsList((prev) => ({
          ...prev,
          [chatId]: {
            ...Object.assign(
              ...widgets.conversations[chatId]?.map((widget) => ({
                [widget?.id]: {
                  ...widget,
                  chatId,
                },
              }))
            ),
          },
        }))
      }
    }
  }, [activeConversation, widgetSelected])

  const handleSelectWidget = useCallback(
    (widget) => {
      if (widget === widgetSelected) return
      dispatch(setActiveWidget(activeConversation, widget))
    },
    [activeConversation, widgetSelected]
  )

  //IFRAME

  const checkTicketTelefone = () => {
    if (conversation) {
      return (
        conversation?.channel === 'real_automation' ||
        conversation?.channel === 'telefone'
      )
    }

    return false
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          backgroundImage:
            theme.palette.type === 'dark'
              ? 'url(/background-dark.png)'
              : 'url(/background-light.png)',
          backgroundPosition: '120% 50%',
          backgroundSize: '80%',
          backgroundRepeat: 'no-repeat',
          marginLeft: '0.5em',
        }}
      >
        <DockMenu
          widgetSelected={widgetSelected}
          handleSelectWidget={handleSelectWidget}
          isTicket={props?.ticket}
          isAiSummaryEnabled={conversation?.isAiSummaryEnabled || false}
          haveLink={haveLink}
        />
        <div
          className={classes.widgetsContent}
          style={{
            ...(widgetSelected === 'link' ? { minWidth: 0, width: 0 } : {}),
          }}
        >
          {widgetSelected === 'attendance' && (
            <Data
              ticket={
                conversation && conversation?.channel === 'real_automation'
                  ? true
                  : false
              }
            />
          )}

          {widgetSelected === 'knowledge' && <TreeOfKnowledge />}
          {widgetSelected === 'summary' && <SummarizationWidget />}
          {widgetSelected === 'historic' && !checkTicketTelefone() && (
            <History
              consumerId={conversation?.consumer?.id}
              channel={conversation?.channel}
            />
          )}
        </div>
        {showWidgets()}
      </div>
      <div style={{ height: '100vh' }}></div>
    </>
  )
}

export default memo(Dock)
